import React, { useContext } from 'react';
import {
  HighFiveIcon,
  HistoryPayIcon,
  PACIcon,
  PATWompayIcon,
} from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons';
import { navigate } from 'gatsby';
import Button from '@womcorp/wom-miwom-ui-kit/dist/components/Button';
import PropTypes from 'prop-types';
import { InfoPill } from '@womcorp/wom-miwom-ui-kit/dist/components/InfoPill';
import {
  AmountPayContainerStyled,
  DueDateContainerStyled,
  MoreServicesStyled,
  NotPaidContainerStyled,
  PaidButtonCotainerStyled,
  PaidContainerStyled,
  PaidMessageStyled,
  PATMessageStyled,
  PaymentButtonContainerStyled,
  PaymentContainerStyled,
  PaymentInfoStyled,
} from './styles/StatusBarStyled';
import PayButton from '../PaymentMethods/PayButton/PayButton';
import { GoogleTagManager, Numbers } from '../../helpers';
import PageContext from '../../contextProvider/PageContext';
import { redirectToWompay } from '../../helpers/Redirect';

const infoPills = {
  created: { message: 'TU BOLETA ACTUAL', variant: 'neutral' },
  warning: {
    message: 'TU ÚLTIMA BOLETA ESTÁ POR VENCER',
    variant: 'warning',
  },
  not_paid: { message: 'TU ÚLTIMA BOLETA ESTÁ VENCIDA', variant: 'danger' },
  expired: {
    message: 'TIENES UNA O MÁS BOLETAS VENCIDAS',
    variant: 'danger',
  },
};

const states = {
  no_bills: {
    title: 'Estado de boletas',
    subtitle:
      'Desde el próximo mes en esta sección verás el resumen de tu boleta',
    icon: <HistoryPayIcon />,
    showMoreDetails: false,
  },
  paid: {
    title: '¡Tu cuenta está al día!',
    icon: <HighFiveIcon />,
    showViewDetail: true,
    showMoreDetails: true,
  },
  not_paid: {
    showViewDetail: true,
    showMoreDetails: true,
  },
  expired: {
    showViewDetail: true,
    showMoreDetails: true,
  },
  PAC: {
    title: 'Suscrito a Pago Automático de Cuentas',
    subtitle:
      'El pago de tu boleta se realizará con cargo a tu cuenta bancaria',
    icon: <PACIcon />,
    showViewDetail: true,
    showMoreDetails: false,
  },
  wompay: {
    title: 'Suscrito a Pago Automático WOMPAY',
    subtitle:
      ' Si el monto no sobrepasa tu límite de WOMPAY, tu cuenta se pagará automáticamente',
    icon: <PATWompayIcon />,
    showViewDetail: true,
    showMoreDetails: false,
  },
};

const InvoiceStatus = ({
  invoicesStatus,
  paymentUrl,
  last6Invoices,
  accountSelected,
  status,
  isMultiAccount,
}) => {
  const { pathname } = useContext(PageContext);
  const normalizedPathname = pathname?.replace(/\/$/, '');

  const MoreServices = notPaid => {
    return (
      <MoreServicesStyled notPaid={notPaid} isMultiAccount={isMultiAccount}>
        <p>Si tienes más servicios</p>
        <a href={paymentUrl} target="_blank" rel="noreferrer">
          Revisa aquí todas tus cuentas
        </a>
      </MoreServicesStyled>
    );
  };

  const ViewInvoiceDetails = () => {
    return (
      <Button
        variant="outlined"
        onClick={() => {
          navigate('/mis-boletas');
          GoogleTagManager.tagInteractiveEvent({
            eventCategory: 'Status Bar',
            eventAction: `Presionar Botón - Status bar - Ver detalle`,
            eventTag: `Presionar Botón - Status bar - Ver detalle`,
          });
        }}
        color="corporate"
      >
        VER DETALLE
      </Button>
    );
  };

  const WompayButton = () => {
    return (
      <Button
        variant="outlined"
        color="corporate"
        onClick={() => {
          redirectToWompay('pat');
        }}
      >
        IR A WOMPAY
      </Button>
    );
  };
  if (
    status === 'paid' ||
    status === 'wompay' ||
    status === 'PAC' ||
    status === 'no_bills'
  )
    return (
      <>
        <PaidContainerStyled status={status} pathname={normalizedPathname}>
          {status === 'paid' ? (
            <PaidMessageStyled>
              {states[status]?.icon} {states[status]?.title}
            </PaidMessageStyled>
          ) : (
            <PATMessageStyled>
              {states[status]?.icon}
              <div>
                {states[status]?.title}
                {states[status]?.subtitle && <p>{states[status]?.subtitle}</p>}
              </div>
            </PATMessageStyled>
          )}
          {((states[status]?.showViewDetail &&
            normalizedPathname === '/home') ||
            (status === 'wompay' && normalizedPathname !== '/home')) && (
            <PaidButtonCotainerStyled>
              {states[status]?.showViewDetail &&
                normalizedPathname === '/home' &&
                ViewInvoiceDetails()}
              {status === 'wompay' &&
                normalizedPathname !== '/home' &&
                WompayButton()}
            </PaidButtonCotainerStyled>
          )}
        </PaidContainerStyled>
        {states[status]?.showMoreDetails && MoreServices(false)}
      </>
    );
  const { debtStatus, amountToPay } = invoicesStatus;
  return (
    <>
      <NotPaidContainerStyled
        isMultiAccount={isMultiAccount}
        status={status}
        pathname={normalizedPathname}
      >
        <InfoPill
          label={
            debtStatus === 'expired'
              ? infoPills.expired.message
              : infoPills[debtStatus].message
          }
          variant={
            debtStatus === 'expired'
              ? infoPills.expired.variant
              : infoPills[debtStatus].variant
          }
        />
        <PaymentContainerStyled
          status={debtStatus}
          isMultiAccount={isMultiAccount}
        >
          <PaymentInfoStyled status={status}>
            <AmountPayContainerStyled>
              <p>El total a pagar:</p>
              <p>${Numbers.addThousandSeparators(amountToPay)}</p>
            </AmountPayContainerStyled>
            {debtStatus !== 'expired' && debtStatus !== 'not_paid' && (
              <DueDateContainerStyled>
                <p>Vence el</p>
                <p>{last6Invoices.lastInvoice.dueDate}</p>
              </DueDateContainerStyled>
            )}
          </PaymentInfoStyled>
          <PaymentButtonContainerStyled
            status={debtStatus}
            isMultiAccount={isMultiAccount}
          >
            {normalizedPathname === '/home' && ViewInvoiceDetails()}
            <PayButton
              title="Ir a pagar"
              invoicesStatus={invoicesStatus}
              paymentUrl={paymentUrl}
              last6Invoices={last6Invoices}
              accountSelected={accountSelected}
            />
          </PaymentButtonContainerStyled>
        </PaymentContainerStyled>
      </NotPaidContainerStyled>
      {MoreServices(true)}
    </>
  );
};

InvoiceStatus.propTypes = {
  invoicesStatus: PropTypes.shape({
    debtStatus: PropTypes.string,
    amountToPay: PropTypes.number,
    idInvoice: PropTypes.string,
  }).isRequired,
  paymentUrl: PropTypes.string.isRequired,
  last6Invoices: PropTypes.shape({
    lastInvoice: PropTypes.shape({
      amount: PropTypes.number,
      amountToPay: PropTypes.number,
      dueDate: PropTypes.string,
      month: PropTypes.string,
      documentId: PropTypes.string,
      status: PropTypes.string,
      urlFactura: PropTypes.string,
    }),
    lastSemester: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number,
        amountToPay: PropTypes.number,
        dueDate: PropTypes.string,
        month: PropTypes.string,
        documentId: PropTypes.string,
        status: PropTypes.string,
        urlFactura: PropTypes.string,
      })
    ),
  }).isRequired,
  accountSelected: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  isMultiAccount: PropTypes.bool.isRequired,
};

export default InvoiceStatus;
